// ** React Imports
import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Search, DollarSign, Key, Upload } from "react-feather";
import { getUserRole } from "../../utility/Utils";

// ** Third Party Components

// ** Reactstrap Imports
import { Row, Col, TabContent, TabPane, Button  } from "reactstrap";

// ** Demo Components
import Tabs from "./Tabs";
import AccountTabContent from "./AccountTabContent";

// ** Styles
import "@styles/react/libs/flatpickr/flatpickr.scss";
import "@styles/react/pages/page-account-settings.scss";
import PageHeader from "../../@core/components/PageHeader";

const AccountSettings = () => {
  const navigate = useNavigate();
  let currentTab = "1";
  const [activeTab, setActiveTab] = useState(currentTab);
  const location = useLocation();

  const params = new URLSearchParams(location.search);
 
   useEffect(()=>{
     if(location.search){
       currentTab =  params.get('tab');
       setActiveTab(currentTab);
     }else{
       currentTab = '1';
       setActiveTab(currentTab);
     }
 
   }, [location.search]);


  const toggleTab = tab => {
    setActiveTab(tab);
  };

  return (<>
      <PageHeader
        pageName={`Settings`}
        backButtonEnabled={true}
      />
      <div className="container-fluid vh-85">
      <div className='page-header' style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0' }}>
            <div className='tab-container'>
              <div className='section-head' style={{ fontSize: '20px', color: 'black', paddingBottom: '10px' }}>Settings</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {/* <Button color="success" onClick={() => navigate('/products-and-plans')}> <DollarSign size={14} /> Upgrade</Button> */}
            </div>
          </div>
        <Row>
          <Col xs={12}>
            <div style={{ width: "100%", marginBottom: "10px" }}></div>
            <Tabs className="mb-2" activeTab={activeTab} toggleTab={toggleTab} />
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <AccountTabContent />
              </TabPane>
              {/* <TabPane tabId="2">
                <CompanyTabContent />
              </TabPane> */}
            {
              <TabPane tabId="3">
                {/* <BillingTabContent /> */}
              </TabPane>
            }

            </TabContent>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AccountSettings;
